import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'

import makeData from './makeData'
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {getStore} from "../../../index";
import ModalExample from "./contactus";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table2({ columns, data, type,customer,sample}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // Render the UI for your table
  console.log(rows)
  console.log(data)
  return (
    <div className="tablewrapper">
      <table {...getTableProps()} >
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()} >
          {/*<th>Select</th>*/}
          {headerGroup.headers.map(column => (
            <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>{column.render('Header')}</th>
          ))}
        </tr>
      ))}
      </thead>
      <tbody {...getTableBodyProps()}>
      <tr>
        <td style={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>{sample("sourcecode")}}>Example Sample</td>
        <td>Teradata</td>
        <td>1000/10MB</td>
        <td style={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>{sample("freeassessment")}}>view</td>
        <td style={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>{sample("proassessment")}}>view</td>
        <td style={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>{sample("translation")}}>view</td>
        <td></td>
      </tr>
      {rows.map((row, i) => {
        prepareRow(row)
        // if(row.values.status != "DELETED" && row.values.username !== username){
        // if(row.values.username !== username){
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                if(cell.column.Header === "Analyzer Report(Free)"){
                  if(type === 'np'){
                    return <td {...cell.getCellProps()} className="textUnderline"> <Link to={`/en-CA/assessment/free/${data[i]['reponame']}/${customer}`}>View </Link></td>
                  }else{
                    if(data[i]['jobType'] === "FreeAssessment"){
                      if(data[i]['jobStatus'] === "success"){
                        return <td {...cell.getCellProps()} className="textUnderline"> <Link to={`/en-CA/assessment/free/${data[i]['reponame']}`}>View </Link></td>
                      }else{
                        return <td {...cell.getCellProps()} className="textUnderline"> <Link to={`/en-CA/assessment/free/${data[i]['reponame']}`}>Create </Link></td>
                      }
                    }
                  }
                }
                else if(cell.column.Header === "Analyzer Report(Pro)"){
                  if(type === 'np'){
                    return <td {...cell.getCellProps()} className="textUnderline"></td>
                  }else{
                    return <td {...cell.getCellProps()} className="textUnderline"><ModalExample hasTitle
                                                                                                info
                                                                                                className="modal_lg"
                                                                                                store = {getStore()}
                    >
                    </ModalExample></td>
                  }
                }
                else if(cell.column.Header === "Translate Files"){
                  if(type === 'np'){
                    return <td {...cell.getCellProps()} className="textUnderline"></td>
                  }else{
                    return <td {...cell.getCellProps()} className="textUnderline"><ModalExample hasTitle
                                                                                                info
                                                                                                className="modal_lg"
                                                                                                store = {getStore()}
                    >
                    </ModalExample></td>
                  }
                }
                else if(cell.value !== "null"){
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                }
                else{
                  return <td {...cell.getCellProps()}></td>
                }
              })}
            </tr>
          )
        // }
      })}
      </tbody>
    </table>
    </div>
  )
}

function App(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Source Code Project Name',
        accessor: 'reponame', // accessor is the "key" in the data
      },
      {
        Header: 'Source Language',
        accessor: 'srclang',
      },
      {
        Header: 'Details(Files/Size)',
        accessor: 'file', // accessor is the "key" in the data
      },
      {
        Header: 'Analyzer Report(Free)',
        accessor: 'free', // accessor is the "key" in the data
      },
      {
        Header: 'Analyzer Report(Pro)',
        accessor: 'pro', // accessor is the "key" in the data
      },
      {
        Header: 'Translate Files',
        accessor: 'trans', // accessor is the "key" in the data
      },
      {
        Header: ' ',
        accessor: 'status', // accessor is the "key" in the data
      }
    ],
    []
  );

  // const data2 = React.useMemo(() => makeData(20), [])
  console.log(props)

  return (
    <Styles>
      <Table2 columns={columns} data={props.data} type={props.type} customer={props.customer} sample={props.sample} />
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/Snowflake/table2.js